return;
(function () {
  'use strict';

  const stickyBar     = document.getElementById('elyora-sticky-atc');
  const btnMobile     = document.getElementById('elyora-btn-mobile');
  const btnDesktop    = document.getElementById('elyora-btn-desktop');
  const variantLabel  = document.getElementById('elyora-variant-label');

  if (!stickyBar) return;

  const mainForm = document.querySelector('form[action="/cart/add"]');
  const mainBtn  = mainForm
    ? mainForm.querySelector('[type="submit"], [name="add"]')
    : null;

  let currentVariantId  = null;
  let currentAvailable  = true;

  if (mainBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0 }
    );
    observer.observe(mainBtn);
  } else {
    window.addEventListener('scroll', () => {
      stickyBar.classList.toggle('is-visible', window.scrollY > 300);
    }, { passive: true });
  }

  function updateBar(variant) {
    if (!variant) return;
    currentVariantId = variant.id;
    currentAvailable = variant.available;
    if (variantLabel) {
      const isDefault = variant.title === 'Default Title';
      variantLabel.textContent = isDefault ? '' : variant.title;
      variantLabel.dataset.default = isDefault ? 'true' : 'false';
    }
    [btnMobile, btnDesktop].forEach(btn => {
      if (!btn) return;
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'AJOUTER AU PANIER' : 'INDISPONIBLE';
      btn.classList.remove('is-loading', 'is-success');
    });
  }

  document.addEventListener('variant:changed', (e) => {
    if (e.detail && e.detail.variant) updateBar(e.detail.variant);
  });

  const variantSelects = document.querySelectorAll(
    'select[name="id"], input[name="id"], fieldset input[type="radio"]'
  );

  variantSelects.forEach(el => {
    el.addEventListener('change', () => {
      let selectedId;
      if (el.tagName === 'SELECT') {
        selectedId = el.value;
      } else if (el.type === 'radio' && el.checked) {
        selectedId = document.querySelector('input[name="id"]:checked')?.value
                  || document.querySelector('[data-variant-id]')?.dataset.variantId;
      } else {
        selectedId = el.value;
      }
      if (!selectedId) return;
      const product = window.productJSON || window.__productJSON;
      if (product && product.variants) {
        const variant = product.variants.find(v => String(v.id) === String(selectedId));
        if (variant) updateBar(variant);
      } else {
        currentVariantId = selectedId;
        [btnMobile, btnDesktop].forEach(btn => {
          if (btn) btn.dataset.variantId = selectedId;
        });
      }
    });
  });

  (function initVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    const product = window.productJSON || window.__productJSON;
    if (product && product.variants) {
      const id = variantFromUrl || product.selected_or_first_available_variant_id;
      const variant = product.variants.find(v => String(v.id) === String(id))
                   || product.variants[0];
      if (variant) updateBar(variant);
    } else {
      const fallbackId = btnMobile?.dataset.variantId || btnDesktop?.dataset.variantId;
      if (fallbackId) currentVariantId = fallbackId;
    }
  })();

  async function addToCart(btn) {
    const variantId = btn.dataset.variantId || currentVariantId;
    if (!variantId || !currentAvailable) return;
    const originalText = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Ajout…';
    btn.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!response.ok) throw new Error('Cart error');
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.textContent = '✓ Ajouté !';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(() => {
        btn.classList.remove('is-success');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.textContent = 'Erreur — réessayer';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = originalText; }, 2500);
    }
  }

  [btnMobile, btnDesktop].forEach(btn => {
    if (!btn) return;
    btn.addEventListener('click', () => addToCart(btn));
  });

})();